<aside class="feature-info-panel" aria-label="Información de parcela">
  <header>
    <h2>{{ data.title }}</h2>
    <button type="button" aria-label="Cerrar información" (click)="close()">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
  </header>

  <p class="parcel-ref">
    <span>{{ data.referenceLabel || 'Referencia catastral' }}</span>
    <strong>{{ data.cadastralReference }}</strong>
  </p>

  <nav class="parcel-tabs" aria-label="Detalle de parcelas">
    <button type="button" class="active">Información</button>
  </nav>

  <dl class="parcel-data-list">
    @for (row of data.rows; track row.kind + row.label) {
      <div>
        <dt>
          @switch (getRowIconPath(row)) {
            @case ('surface') {
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 14v6h6" />
                <path d="M20 10V4h-6" />
                <path d="M20 4 13 11" />
                <path d="M4 20l7-7" />
              </svg>
            }
            @case ('take') {
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 12c3-5 8-5 11-2" />
                <path d="M13 5h6v6" />
                <path d="M19 5 12 12" />
              </svg>
            }
            @default {
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="3" y="5" width="18" height="16" rx="2" />
                <path d="M16 3v4" />
                <path d="M8 3v4" />
                <path d="M3 11h18" />
              </svg>
            }
          }
          {{ row.label }}
        </dt>
        <dd>
          @if (row.badge) {
            <span class="pill" [class.open]="row.badge === 'open'" [class.closed]="row.badge === 'closed'" [class.unknown]="row.badge === 'unknown'">
              {{ row.value }}
            </span>
          } @else if (row.valueLines?.length) {
            <span class="value-lines">
              @for (line of row.valueLines; track line) {
                <span>{{ line }}</span>
              }
            </span>
          } @else {
            {{ row.value }}
          }
        </dd>
      </div>
    }
  </dl>

  @if (guardTake) {
    <form class="take-operation-form" (submit)="submitGuardTakeStatus($event)">
      <div class="take-operation-heading">
        <h3>Registrar operación</h3>
        <p>Indica el nuevo estado. La fecha y hora se registrarán automáticamente.</p>
      </div>

      <fieldset>
        <legend>Nuevo estado</legend>
        <div class="take-status-options">
          <button
            type="button"
            class="open-option"
            [class.current]="guardTake.status === 'abierta'"
            [class.selected]="selectedGuardTakeStatus === 'abierta'"
            [attr.aria-pressed]="selectedGuardTakeStatus === 'abierta'"
            [attr.title]="guardTake.status === 'abierta' ? 'Estado actual' : null"
            [disabled]="guardTakeStatusSaving || guardTake.status === 'abierta'"
            (click)="selectGuardTakeStatus('abierta')"
          >
            <span aria-hidden="true"></span>
            Abierta
          </button>
          <button
            type="button"
            class="closed-option"
            [class.current]="guardTake.status === 'cerrada'"
            [class.selected]="selectedGuardTakeStatus === 'cerrada'"
            [attr.aria-pressed]="selectedGuardTakeStatus === 'cerrada'"
            [attr.title]="guardTake.status === 'cerrada' ? 'Estado actual' : null"
            [disabled]="guardTakeStatusSaving || guardTake.status === 'cerrada'"
            (click)="selectGuardTakeStatus('cerrada')"
          >
            <span aria-hidden="true"></span>
            Cerrada
          </button>
        </div>
      </fieldset>

      @if (guardTakeStatusError) {
        <p class="take-operation-error" role="alert">{{ guardTakeStatusError }}</p>
      }

      <button
        type="submit"
        class="save-take-operation"
        [disabled]="!selectedGuardTakeStatus || guardTakeStatusSaving || selectedGuardTakeStatus === guardTake.status"
      >
        {{ guardTakeStatusSaving ? 'Guardando...' : 'Guardar operación' }}
      </button>
    </form>
  }
</aside>
